export default function getUrl(item, { shareId, embedMode } = {}) {
  if (!item.type) {
    console.error('Item with no name or type!', item)
    return '/'
  }
  const bits = [safeName(item.name || ''), item.type.substr(0, 1) + item.id]
  if (shareId && shareId !== 'open') bits.push('s' + shareId)
  if (embedMode) bits.push('embed')
  return `/${bits.join('.')}/`
}

export const safeName = name =>
  name
    // everything not in list becomes -
    .replace(/[^0-9a-zA-Z-$_+!*();:@=&]/g, '-')
    // multiple --- become -
    .replace(/-{2,}/g, '-')
    // -leading and trailing- removed
    .replace(/^-/, '')
    .replace(/-$/, '')
    // ensure not blank
    .replace(/^$/, '-')
